const list = document.querySelectorAll(".collapsible-lists > dt");

for(let i = 0, length1 = list.length; i < length1; i++){
    list[i].onclick = function(){
        this.classList.toggle('open');
    }
}